import React, { useState } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { motion, AnimatePresence } from 'framer-motion';
import { ToastContainer, toast } from 'react-toastify';
import { BG_IMAGE_URLS, TOASTIFY_NEWEST_ON_TOP } from './config/config.js';
import BackToHome from '../../../components/hospital/navigation/BackToHome.js';
import PharmacyForgotPassword from '../../../components/pharmacy/form/forgotpassword.js';

const Page = () => {
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.contentWrapper)}>
        <div className={css(styles.imageSection)}>
          <img
            src={BG_IMAGE_URLS.forgotPasswordPage}
            alt='Medical illustration'
            className={css(styles.image)}
          />
        </div>
        <motion.div
          className={css(styles.formContainer)}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* <img
                        src={'frontend/assets/M-TREAT.png'}
                        alt="Company logo"
                        className={css(styles.logo)}
                    /> */}
          <h1 className={css(styles.title)}>Forgot Password?</h1>
          <p className={css(styles.tagline)}>Enter your email to reset it.</p>
          <BackToHome />
          <AnimatePresence mode='wait'>
            <motion.div
              key='forgotPassword'
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 20 }}
              transition={{ duration: 0.3 }}
            >
              <PharmacyForgotPassword toast={toast} />
            </motion.div>
          </AnimatePresence>
        </motion.div>
      </div>
      <ToastContainer newestOnTop={TOASTIFY_NEWEST_ON_TOP} />
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f0f4f8',
    fontFamily: "'Roboto', sans-serif",
    padding: '2rem'
  },
  contentWrapper: {
    display: 'flex',
    maxWidth: '1200px',
    width: '100%',
    backgroundColor: 'white',
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.05)'
  },
  imageSection: {
    flex: 1,
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'block'
    }
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  formContainer: {
    flex: 1,
    padding: '2.5rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: '500px',
    margin: '0 auto'
  },
  logo: {
    alignSelf: 'center',
    marginBottom: '1.5rem',
    width: '100px',
    height: 'auto'
  },
  title: {
    color: 'black',
    textAlign: 'center',
    marginBottom: '1rem',
    fontSize: '2rem',
    fontWeight: '700'
  },
  tagline: {
    color: '#555',
    textAlign: 'center',
    marginBottom: '2rem',
    fontSize: '1rem',
    fontWeight: '400'
  },
  toggleText: {
    textAlign: 'center',
    marginTop: '1.5rem',
    color: '#4a5568'
  },
  toggleLink: {
    color: '#2783F7',
    cursor: 'pointer',
    fontWeight: '600',
    ':hover': {
      textDecoration: 'underline'
    }
  }
});

export default Page;
